<div class="tt-c-product-about">
  <tt-product-image  class="tt-c-product-about__image" :catItem="catItem" :isLinkable="true" :size="imageSize"></tt-product-image>
  <div class="tt-c-product-about__info">
    <div v-if="showAbout" class="tt-c-product-about__about" v-html="$msg('productAbout.about')"></div>
    <a :href="catItem.url" class="tt-c-product-about__link" target="_blank" rel="nofollow" v-html="catItem.title"></a>
  </div>
</div>
